import React, { useState, useCallback, useLayoutEffect } from 'react';
import 'resize-observer-polyfill';

const getSize = (element) => {
  if (!element) {
    return {};
  }
  return element.getBoundingClientRect();
};

const useComponentSize = (ref) => {
  const element = typeof ref === 'function' ? ref() : ref?.current;
  const [componentSize, setComponentSize] = useState(getSize(element ?? null));
  const handleResize = useCallback(() => {
    if (element) {
      setComponentSize(getSize(element));
    }
  }, [element]);

  useLayoutEffect(() => {
    if (!element) {
      return;
    }
    handleResize();
    if (typeof ResizeObserver === 'function') {
      let resizeObserver = new ResizeObserver(() => handleResize());
      resizeObserver.observe(element);
      return () => {
        resizeObserver.disconnect(element);
        resizeObserver = null;
      };
    } else {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [handleResize, element]);

  return componentSize;
};

export default useComponentSize;
